import axios from "axios";

const http = axios.create({
    baseURL: global.API_URI || "",
})

http.interceptors.response.use(function (resp) {
    return Promise.resolve(resp.data);
});

export default {
    handleAuth(hash) {
        return http.post('/oauth/callback',{hash})
    }
}